import { FUTURO } from '../../../foundations/color';
import { standard } from './standard';

export const futuroDark = {
  ...standard,
  height: {
    large: '3.5rem',
    medium: '3rem',
    default: '3rem',
  },
  tooltip: {
    bg: FUTURO.DARK.STORM,
    text: FUTURO.DARK.SWAN,
  },
  error: {
    text: FUTURO.DARK.ROSE,
  },
  boxShadow: {
    active: 'none',
    inActive: 'none',
    error: 'none',
  },
  borderRadius: '4px',
  background: {
    active: FUTURO.DARK.WHITE,
    inActive: FUTURO.DARK.SMOKE,
    error: FUTURO.DARK.WHITE,
  },
  border: {
    active: `2px solid ${FUTURO.DARK.SILVER}`,
    inActive: `2px solid ${FUTURO.DARK.SILVER}`,
    error: `2px solid ${FUTURO.DARK.ROSE}`,
  },
  color: {
    active: FUTURO.DARK.STORM,
    inActive: FUTURO.DARK.STORM,
    error: FUTURO.DARK.STORM,
  },
  labelColor: {
    active: FUTURO.DARK.SPACE,
    inActive: FUTURO.DARK.STEEL,
    error: FUTURO.DARK.ROSE,
  },
  hintColor: {
    active: FUTURO.DARK.STEEL,
    inActive: FUTURO.DARK.SHADOW,
    error: FUTURO.DARK.STEEL,
  },
  errorLabelColor: {
    error: FUTURO.DARK.ROSE,
  },
};
